import Layout from '@/layout'

const route = {
  path: '/TkReleaseGroup',
  component: Layout,
  redirect: '/TKReleaseGroup/index',
  alwaysShow: true, // will always show the root menu
  name: 'releaseGroup',
  meta: {
    title: '巨量投放报表',
    icon: 'ORR',
    roles: [
      'ocean_release_report'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/TKreleaseGroup/releaseGroupList/index',
      component: () => import('@/views/TKreleaseGroup/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          'ocean_release_report.release_group'
        ]
      }
    },
    {
      path: '/TKreleaseGroup/sendcicle/index',
      component: () => import('@/views/TKreleaseGroup/WechatAppGroupList/sendcicle/index.vue'),
      name: 'Sendcicle',
      meta: {
        title: '小程序广告主列表',
        // icon: 'component',
        roles: [
          'ocean_release_report.mini_program'
        ]
      },
      hidden: true
    },
    {
      path: '/TKreleaseGroup/WechatAppGroupList/index',
      component: () => import('@/views/TKreleaseGroup/WechatAppGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '小程序列表',
        icon: 'component',
        roles: [
          'ocean_release_report.mini_program'
        ]
      }
    },
    {
      path: '/TKreleaseGroup/bindingRelationList/index',
      component: () => import('@/views/TKreleaseGroup/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          'ocean_release_report.bind_wechat'
        ]
      }
    }, {
      path: '/TKreleaseGroup/reportList/index',
      component: () => import('@/views/TKreleaseGroup/reportList/index.vue'),
      name: 'reportList',
      meta: {
        title: '报表列表',
        icon: 'component',
        roles: [
          'ocean_release_report.bind_wechat_report'
        ]
      }
    }, {
      path: '/TKreleaseGroup/totalReportList/index',
      component: () => import('@/views/TKreleaseGroup/totalReportList/index.vue'),
      name: 'totalReportList',
      meta: {
        title: '总计报表',
        icon: 'component',
        roles: [
          'ocean_release_report.bind_wechat_total_report'
        ]
      }
    }, {
      path: '/TKreleaseGroup/hourReportList/index',
      component: () => import('@/views/TKreleaseGroup/hourReportList/index.vue'),
      name: 'hourReportList',
      meta: {
        title: '小时报表',
        icon: 'component',
        roles: [
          'ocean_release_report.bind_wechat_hour_report'
        ]
      }
    }
  ]
}

export default route
